import React from 'react';
import { startCase, toLower } from 'lodash';
import PropTypes from 'prop-types';

import BooleanRequirements
  from '../../../../../../../components/RequirementBlocks/InsurancePolicyBlock/BooleanRequirements';
import InsurancePolicyCard
  from '../../../../../../../components/RequirementBlocks/InsurancePolicyBlock/InsurancePolicyCard';
import InsurancePolicyRequirements
  from '../../../../../../../components/RequirementBlocks/InsurancePolicyBlock/InsurancePolicyRequirements';
import NonbooleanRequirements
  from '../../../../../../../components/RequirementBlocks/InsurancePolicyBlock/NonbooleanRequirements';
import RequirementBlockCardHeader from '../../../../../../../components/RequirementBlocks/RequirementBlockCardHeader';
import { get } from '../../../../../../../utils/arrayUtil';
import { getDisplayValueForType } from '../../../../../../../utils/tableUtil';

function InsurancePolicyTemplateBlock({ requirementBlock, isArchived }) {
  const { policyTypeDisplayName } = requirementBlock.requirementTemplateBlockProperties[0];

  const booleanProperties = requirementBlock.requirementTemplateBlockProperties
    .filter(blockProperty => (blockProperty?.requirement?.dataType === 'boolean'));

  const nonBooleanProperties = requirementBlock.requirementTemplateBlockProperties
    .filter(blockProperty => (blockProperty?.requirement?.dataType !== 'boolean'));

  const booleanComponent = (booleanProperties?.length > 0) && booleanProperties.map(booleanProperty => {
    if (booleanProperty?.requirement) {
      if (get(booleanProperty, 'value', 0) > 0) {
        const displayName = startCase(toLower(get(booleanProperty, 'requirement.displayName', '')));
        return (
          <BooleanRequirements displayName={displayName} isArchived={isArchived} key={booleanProperty.id} />
        );
      }
    }
  });

  const nonBooleanComponent = (nonBooleanProperties.length > 0) && nonBooleanProperties.map(property => {
    if (property?.requirement) {
      const propertyName = `${startCase(toLower(get(property, 'requirement.displayName', '')))}: `;
      const propertyValue = `${property.value
        ? getDisplayValueForType(property.value, get(property, 'requirement.dataType', '')) : '-'}`;
      return (
        <NonbooleanRequirements
          isArchived={isArchived}
          key={property.requirement.id}
          propertyName={propertyName}
          propertyValue={propertyValue}
        />
      );
    }
  });

  const isRequired = requirementBlock.required;

  return (
    <InsurancePolicyCard isArchived={isArchived}>
      <RequirementBlockCardHeader displayName={policyTypeDisplayName} isArchived={isArchived} isRequired={isRequired} />
      <InsurancePolicyRequirements booleanProperties={booleanComponent} nonBooleanProperties={nonBooleanComponent} />
    </InsurancePolicyCard>
  );
}

InsurancePolicyTemplateBlock.propTypes = {
  requirementBlock: PropTypes.shape({
    requirementTemplateBlockProperties: PropTypes.shape({
      policyTypeDisplayName: PropTypes.string
    }),
    required: PropTypes.bool
  }),
  isArchived: PropTypes.bool
};

export default InsurancePolicyTemplateBlock;
